import api from './ApiServices'

export default class GuestService {
  static async getEnum (enumName) {
    const response = await api(
      `query {
        enumOptions(name: "${enumName}") {
          key
          val
        }
      }`
    )
    if (response.error !== null) return false
    else return response.data.enumOptions
  }

  static async listProfessions (limit = 100, offset = 0) {
    const response = await api(
      `query {
            listProfessionalType(limit: ${limit}, offset: ${offset}) {
                id
                name
            }
        }`
    )
    if (response.error !== null) return false
    else return response.data.listProfessionalType
  }
  
  static async listCompanyTypes (limit = 100, offset = 0) {
    const response = await api(
      `query {
          listCompanyType(limit: ${limit}, offset: ${offset}) {
                id
                name
            }
        }`
    )
    if (response.error !== null) return false
    else return response.data.listCompanyType
  }

  static async listExperiences (limit = 100, offset = 0) {
    const response = await api(
      `query {
            listNumExperience(limit: ${limit}, offset: ${offset}) {
                id
                name
            }
        }`
    )
    if (response.error !== null) return false
    else return response.data.listNumExperience
  }

  static async listSpecialisations (limit = 100, offset = 0) {
    const response = await api(
      `query {
            listNurseType(limit: ${limit}, offset: ${offset}) {
                id
                name
            }
        }`
    )
    if (response.error !== null) return false
    else return response.data.listNurseType
  }

  static async listNurseType (professionId, limit = 100, offset = 0) {
    const response = await api(
      `query {
            listNurseType(profession:"${professionId}", limit : ${limit}, offset : ${offset}) {
                id
                name
            }
        }`
    )
    if (response.error !== null) return false
    else return response.data.listNurseType
  }

  static async listQualifications (limit = 100, offset = 0) {
    const response = await api(
      `query {
            listQualificationType(limit: ${limit}, offset: ${offset}) {
                id
                name
            }
        }`
    )
    if (response.error !== null) return false
    else return response.data.listQualificationType
  }

  static async listQualificationsType (professionId, limit = 100, offset = 0) {
    const response = await api(
      `query {
        listQualificationType(
          profession:"${professionId}", limit : ${limit}, offset : ${offset}
        ){
          id
          name
        }
        }`
    )
    if (response.error !== null) return false
    else return response.data.listQualificationType
  }

  static async listCity (limit = 100, offset = 0) {
    const response = await api(
      `query {
            listCity(limit: ${limit}, offset: ${offset}) {
                id
                name
            }
        }`
    )
    if (response.error !== null) return false
    else return response.data.listCity
  }

  static async listLanguage (limit = 100, offset = 0) {
    const response = await api(
      `query {
        listLanguage(limit: ${limit}, offset: ${offset}) {
                id
                name
            }
        }`
    )
    if (response.error !== null) return false
    else return response.data.listLanguage
  }
}
